import React, { useEffect, useState } from "react";

import api from "helpers/api";
import Res from "types/response";
import { setUser } from 'store/user';
import { User, User$ } from "types/user";
import { useTranslation } from "next-i18next";

interface Props { user: User$ }
export function ProfilePhoto({ user }: Props): JSX.Element {
  const { t } = useTranslation();

  const [photo, setPhoto] = useState<string>();
  function preview(event: React.ChangeEvent<HTMLInputElement>): void {
    const file = event.target.files?.item(0);
    file && setPhoto(URL.createObjectURL(file));
  }

  async function upload(files: FileList | null): Promise<void> {
    if (!files?.item(0)) { return; }
    const { data }: Res<Partial<User>>
      = await api.set('v1/users/update-avatar', 'put',
        { body: { avatar: files.item(0) }, formData: true });
    setUser({ ...user as User, ...data });
  }

  async function remove(): Promise<void> {
    const { data }: Res<Partial<User>>
      = await api.set('v1/users/delete-avatar', 'delete');
    setUser({ ...user as User, ...data });
  }

  useEffect(() => () => {
    api.remove('put:v1/users/update-avatar');
    api.remove('delete:v1/users/delete-avatar');
  }, []);

  return (
    <div className="d-flex justify-content-center">
      <div className="d-inline-block text-center position-relative" style={{ minWidth: "20vw" }}>
        <div className="d-flex justify-content-center">
          <figure className="profilePic-wrapper">
            <img className="h-100 w-100 profile-picture"
              src={photo || user?.avatar} alt="user icon" />
          </figure>
        </div>
        <p className="upload-pic  p-4 fs-14 pointer">{t("common:user.uploadphoto")}</p>
        <input id="photo" className="form-control embed"
          type="file" name="photo" onChange={e => upload(e.target.files)} />
        <div className="remove-userpic" onClick={remove}>
          <span className="icon icon-close"></span>
        </div>
      </div>
    </div>
  )
}

export default React.memo(ProfilePhoto);
